import React, { useState, useEffect } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { motion } from 'framer-motion';
import { Lock, Loader2 } from 'lucide-react';
import { toast } from 'sonner';
import { useAuth } from '../../context/AuthContext';
import { useLang } from '../../i18n';
import { Logo } from '../common/Logo';

const StaffLoginPage = () => {
  const navigate = useNavigate();
  const { login, user } = useAuth();
  const { t } = useLang();
  const [loading, setLoading] = useState(false);
  const [formData, setFormData] = useState({ email: '', password: '' });

  useEffect(() => {
    if (user) navigate(`/${user.role}`);
  }, [user, navigate]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const userData = await login(formData.email, formData.password);
      if (userData.role === 'customer') {
        toast.error('Customer accounts cannot access the staff portal.');
        localStorage.removeItem('token');
        window.location.reload();
        return;
      }
      toast.success(`Welcome back, ${userData.name}!`);
      navigate(`/${userData.role}`);
    } catch (err) {
      toast.error(err.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-black flex items-center justify-center p-4">
      <motion.div initial={{ opacity: 0, y: 20 }} animate={{ opacity: 1, y: 0 }} className="w-full max-w-md">
        <Link to="/" className="flex justify-center mb-8"><Logo /></Link>
        <div className="card p-8 bg-gray-900 border-gray-800">
          <div className="flex items-center gap-3 mb-6">
            <div className="w-12 h-12 bg-gray-700 flex items-center justify-center">
              <Lock className="w-6 h-6 text-white" />
            </div>
            <div>
              <h2 className="font-heading text-2xl font-bold text-white" data-testid="staff-login-title">Staff Portal</h2>
              <p className="text-sm text-gray-400">{t('staff_subtitle')}</p>
            </div>
          </div>
          <form onSubmit={handleSubmit} className="space-y-4">
            <input type="email" placeholder="Email Address" className="input" value={formData.email} onChange={(e) => setFormData({ ...formData, email: e.target.value })} required data-testid="staff-email-input" />
            <input type="password" placeholder="Password" className="input" value={formData.password} onChange={(e) => setFormData({ ...formData, password: e.target.value })} required data-testid="staff-password-input" />
            <button type="submit" disabled={loading} className="btn-primary w-full flex items-center justify-center gap-2" data-testid="staff-submit-btn">
              {loading && <Loader2 className="w-4 h-4 animate-spin" />}
              Sign In
            </button>
          </form>
          <p className="text-xs text-gray-600 text-center mt-6">Contact your administrator if you need access.</p>
        </div>
      </motion.div>
    </div>
  );
};

export default StaffLoginPage;
